import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  Configuration,
  ConfigurationId,
} from '@daas-consulting/production/shared/cross/configuration';
import { AuthenticationService } from '@daas-consulting/security/authentication/frontend/data_contracts';
import { Token } from '@daas-consulting/security/authentication/frontend/models';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HttpAuthenticationService implements AuthenticationService {
  readonly #baseUrl: string;
  readonly #http!: HttpClient;

  constructor(
    http: HttpClient,
    @Inject(ConfigurationId) configuration: Configuration
  ) {
    this.#http = http;
    this.#baseUrl = `${configuration.baseUrl}`;
  }

  loginWithCode$(code: string): Observable<Token> {
    return this.#http.get<Token>(`${this.#baseUrl}/security/code/${code}`);
  }

  generateQrCode$(userId: string): Observable<string> {
    const url = `${this.#baseUrl}/users/${userId}/2fa/generate`;
    return this.#http.post(url, null, { responseType: 'text' });
  }

  turnOn$(userId: string, code1: string, code2: string): Observable<void> {
    const url = `${this.#baseUrl}/users/${userId}/2fa/turn-on`;
    return this.#http.post<void>(url, {
      code1,
      code2,
    });
  }

  validate2fa$(userId: string, code: string): Observable<Token> {
    const url = `${this.#baseUrl}/users/${userId}/2fa/validate`;
    return this.#http.post<Token>(url, {
      code,
    });
  }
}
